import { useEffect, useState } from 'react'
import { type NextPage } from 'next'
import BlackBird from 'shared/blackbird'

import { Loader } from '~/domains/platform/design-system/loader/loader'
import { useDeusExMachina } from '~/domains/platform/infra/deus-ex-machina/hocs/with-deus-ex-machina'
import { type Entity, type WithDeusExMachinaProps } from '~/domains/platform/infra/deus-ex-machina/types'
import analitica from '~/domains/stone-account/ports/analitica'
import { CleanPageContainer } from '~/ui/containers'

enum RedirectStatus {
  Loading = 'loading',
  NoRedirect = 'noRedirect'
}

export const WithCreateAccountSituationGuardComponent = ({ Page, ...props }: any) => {
  const { deusExMachina } = useDeusExMachina()
  const entity = deusExMachina?.entity as Entity | undefined
  const [redirectStatus, setRedirectStatus] = useState<RedirectStatus>(RedirectStatus.Loading)

  useEffect(() => {
    if (!entity) return

    const situation = entity.stoneAccount?.situation

    if (situation === 'legacy_affiliation') {
      setRedirectStatus(RedirectStatus.NoRedirect)
      return
    }

    if (situation !== 'one_stone') {
      analitica.events.createAccountGuard.unsupportedSituation(situation)
    }

    BlackBird.goHome()
  }, [entity])

  if (redirectStatus === RedirectStatus.Loading) {
    return (
      <CleanPageContainer>
        <Loader />
      </CleanPageContainer>
    )
  }

  return <Page {...props} />
}

export function withCreateAccountSituationGuard(Page: NextPage<WithDeusExMachinaProps>) {
  return (props: any) => <WithCreateAccountSituationGuardComponent {...props} Page={Page} />
}
